import { useCallback, useEffect, useRef, useState } from "react";
import { refreshToken } from "./security";
import { IRealtimeData } from "../types";
import EnvVars from "./variables";

export interface IWSRequest {
  token?: string;
  tags: string[];
  interval: number;
}

const acquisitionApi = EnvVars.ACQUISITION_API ?? "";
const websocketUri = EnvVars.ACQUISITION_WS ?? "";

const getOptions = (token: string): any => {

  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({ module: "acquisition", query: "temp-token" })
  };
};

export const useRealtimeValues = (): [ (request: IWSRequest, onRetry?: () => void) => void, Record<string, IRealtimeData>, () => void] => {
  const [data, setData] = useState<Record<string, IRealtimeData>>({});
  const websocket = useRef<WebSocket | null>(null);

  useEffect(() => {

    return () => {
      if (websocket.current !== null) {
        websocket.current.close();
        websocket.current = null;
      }
    }
  }, []);

  const stop = useCallback(()  => {
    setData({});
    if (websocket.current !== null) {
      websocket.current.close();
      websocket.current = null;
    }
  }, []);


  const dispatch = useCallback((request: IWSRequest, onRetry?: () => void): void => {
    // let firsTime = false;

    refreshToken().then(token => {
      const options = getOptions(token);

      fetch(acquisitionApi, options)
        .then(response => response.json())
        .then((responseData: { token: string, }) => {
          // console.log("useRealtimeValues", responseData);

          websocket.current = new WebSocket(websocketUri);

          websocket.current.onopen = () => {
            // console.log("websocket.onOpen()");
            if (websocket.current) {
              websocket.current.send(JSON.stringify({ ...request, token: responseData.token }));
            }
          };

          websocket.current.onmessage = (e: any) => {
            // console.log("websocket.onMessage", e.data);
            // if (firsTime) {
            //   firsTime = false;
            //   console.log("websocket.onMessage", e.data);
            // }

            if (e.data) {
              const response: Record<string, any> = JSON.parse(e.data);
              const newRecord: Record<string, IRealtimeData> = {};

              Object.keys(response).map(k => {
                if (response[k]) {
                  const isNumeric = !response[k].Type || response[k].Type === "N";

                  if (newRecord[k]) {
                    newRecord[k].AcquisitionTimeStamp = response[k].AcquisitionTimeStamp;
                    newRecord[k].Error = response[k].Error;
                    newRecord[k].Value = isNumeric ? parseFloat(`${response[k].Value}`) : response[k].Value;
                  } else {
                    newRecord[k] = {
                      AcquisitionTimeStamp: response[k].AcquisitionTimeStamp,
                      Error: response[k].Error,
                      Value: isNumeric ? parseFloat(`${response[k].Value}`) : response[k].Value
                    };
                  }
                } else {
                  newRecord[k] = {
                    AcquisitionTimeStamp: 0,
                    Error: 1,
                    Value: "---"
                  };
                }
              });

              setData(newRecord);
            }
          };

          websocket.current.onclose = (e: any)  => {
            // console.log("websocket.onClose()", e);

            if (!e.wasClean) {
              setData({});

              if (onRetry) {
                setTimeout(() => {
                  // console.log("retrying onclose...");
                  websocket.current = null;
                  onRetry();
                }, 3000);
              }
            }
          };

          websocket.current.onerror = (e: any) => console.error(e);

        })
        .catch((err: Error) => {
          if (err.message === "Failed to fetch" && onRetry) {
            setTimeout(() => {
              // console.log("retrying error...");
              websocket.current = null;
              setData({});
              onRetry();
            }, 3000);
          }
          // console.error(err);
        });
    });
  }, [websocket]);

  return [ dispatch, data, stop ];
};
